<template>
    <div class="components-header-image paddingL20 paddingR20">
        <el-row>
            <el-col :span="16" class="border-R">
                <el-upload
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :before-upload="beforeUpload"
                    accept="image/gif, image/jpeg, image/png, image/bmp"
                    :show-file-list="false"
                >
                    <div class="header-upload-btn">
                        <i class="icon-tupian- iconfont marginR10"></i>
                        选择您要上传的头像
                    </div>
                </el-upload>
                <p class="gray paddingT5">仅支持JPG、GIF、PNG、JPEG、BMP格式，文件小于4M</p>
                <div class="header-co-wrapper marginT20">
                    <vueCropper
                        v-if="isUplaodImage"
                        ref="cropper"
                        :output-type="option.outputType"
                        :auto-crop="option.autoCrop"
                        :full="option.full"
                        :auto-crop-width="option.autoCropWidth"
                        :auto-crop-height="option.autoCropHeight"
                        :fixed-box="option.fixedBox"
                        :center-box="option.centerBox"
                        :img="option.img"
                        :info="option.info"
                        @imgLoad="imgLoad"
                        @realTime="realTime"
                    ></vueCropper>
                    <div v-else class="de-image-wrapper">
                        <img :src="currentImageUrl" alt="" />
                    </div>
                </div>
                <div class="header-submit-wrapper">
                    <p class="title">推荐头像</p>
                    <div class="default-wrapper">
                        <img
                            v-for="(item, index) in defaultImageList"
                            :key="index"
                            :src="item"
                            alt=""
                            @click="selectDefaultImage(item)"
                        />
                    </div>
                    <div class="paddingT10">
                        <el-button type="primary" size="small" @click="submit">保 存</el-button>
                    </div>
                </div>
            </el-col>
            <el-col :span="8" class="paddingL40">
                <p class="title fontBold paddingB10">效果预览</p>
                <p class="paddingB10">你上传的图片会自动生成2种尺寸</p>
                <p class="paddingB10">请注意小尺寸的头像是否清晰</p>
                <div class="header-100">
                    <div class="show-preview">
                        <div class="preview">
                            <img :src="currentImageUrl" />
                        </div>
                    </div>
                    <p class="gray">100*100像素</p>
                </div>
                <div class="header-50">
                    <div class="show-preview">
                        <div class="preview">
                            <img :src="currentImageUrl" />
                        </div>
                    </div>
                    <p class="gray">50*50像素</p>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
// import { VueCropper } from "vue-cropper";
import ossUpload from "@/mixins/oss-upload";
import { mapGetters, mapState } from "vuex";
export default {
    mixins: [ossUpload],

    data() {
        return {
            currentImageUrl: "",
            defaultImageList: [
                this.$config.originURL + "/static/user_default_head/touxiang1.png",
                this.$config.originURL + "/static/user_default_head/touxiang6.png",
                this.$config.originURL + "/static/user_default_head/touxiang2.png",
                this.$config.originURL + "/static/user_default_head/touxiang3.png",
                this.$config.originURL + "/static/user_default_head/touxiang7.png",
                this.$config.originURL + "/static/user_default_head/touxiang4.png",
                this.$config.originURL + "/static/user_default_head/touxiang5.png",
                this.$config.originURL + "/static/user_default_head/touxiang8.png",
            ],
            isUplaodImage: false, // 如果是选择的本地文件则需要先上传
            option: {
                img: "",
                outputSize: 1, //剪切后的图片质量（0.1-1）
                full: false, //输出原图比例截图 props名full
                autoCrop: true,
                outputType: "png",
                // 只有自动截图开启 宽度高度才生效
                autoCropWidth: 120,
                autoCropHeight: 120,
                fixedBox: false,
                centerBox: false,
                info: false,
            },
        };
    },
    computed: {
        ...mapGetters({
            userHeadAvatar: "userHeadAvatar",
        }),
        ...mapState({
            userId: (state) => state.user.oauth.userId,
        }),
    },
    created() {
        this.currentImageUrl = this.userHeadAvatar;
    },
    methods: {
        /**
         * 选择默认头像
         * @param url
         */
        selectDefaultImage(url) {
            this.option.img = url;
            this.currentImageUrl = url;
            this.isUplaodImage = false;
        },
        /**
         * 点击提交头像
         */
        submit() {
            if (!this.isUplaodImage) {
                this.updateImage();
                return;
            }
            this.uploadImage().then((url) => {
                this.currentImageUrl = url;
                this.updateImage();
            });
        },
        updateImage() {
            this.$axios.post("/uc/user/update", { userId: this.userId, avatar: this.currentImageUrl }).then((res) => {
                this.$store.commit("UPDATE_USER_HEADER_IMAGE", this.currentImageUrl);
                this.$message.success("提交成功！");
            });
        },
        /**
         * 添加图片文件
         * @param file
         * @returns {boolean}
         */
        beforeUpload(file) {
            if (file.size > 4 * 1024 * 1024) {
                this.$message.error("上传图片不能超过4M！");
                return;
            }
            const reader = new FileReader();
            let _this = this;
            reader.onload = (e) => {
                let data;
                if (typeof e.target.result === "object") {
                    // 把Array Buffer转化为blob 如果是base64不需要
                    data = window.URL.createObjectURL(new Blob([e.target.result]));
                } else {
                    data = e.target.result;
                }
                _this.option.img = data;
            };
            // 转化为base64
            reader.readAsDataURL(file);
            this.isUplaodImage = true;
            // 转化为blob
            // reader.readAsArrayBuffer(file);
            return false;
        },
        /**
         * 上传图片
         * @param url
         */
        uploadImage() {
            return new Promise((resolve, reject) => {
                this.$refs.cropper.getCropBlob((data) => {
                    // do something
                    data = blobToFile(data);
                    this.ossUpload(data)
                        .then((res) => {
                            if (res.url) {
                                resolve(res.url);
                            } else {
                                reject({});
                            }
                        })
                        .catch((e) => {
                            reject(e);
                        });
                });
            });
        },
        imgLoad(msg) {
            console.log(msg, this.$refs.cropper.cropW);
        },
        realTime() {
            this.$refs.cropper.getCropData((base64) => {
                this.currentImageUrl = base64;
            });
        },
    },
};
function blobToFile(blob, fileName) {
    blob.lastModifiedDate = new Date();
    blob.name = fileName || new Date().getTime();
    return blob;
}
</script>

<style lang="scss" scoped>
.components-header-image {
    max-width: 820px;
}
.header-upload-btn {
    width: 200px;
    height: 32px;
    line-height: 32px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(205, 207, 212, 1);
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
}
.header-co-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 471px;
    height: 238px;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC");
    border: 1px solid rgba(205, 207, 212, 1);
}
.header-submit-wrapper {
    .title {
        font-size: 16px;
        color: #666666;
        padding: 20px 0 0;
    }
    .default-wrapper {
        padding: 10px 0;
        img {
            display: inline-block;
            width: 50px;
            height: 50px;
            margin: 0 10px 10px 0;
            cursor: pointer;
        }
    }
}
.title {
    font-size: 16px;
    color: #666666;
    padding: 0 0 10px;
}
.header-100 {
    margin: 20px 0 30px;
    & > p {
        margin-top: -15px;
    }
    .show-preview {
        display: block;
        width: 120px;
        height: 120px;
        overflow: hidden;
        transform: scale(0.83333333);
        border: 1px solid rgba(205, 207, 212, 1);
        transform-origin: 0 0;
    }
}
.header-50 {
    & > p {
        margin-top: -60px;
    }
    .show-preview {
        display: block;
        width: 120px;
        height: 120px;
        overflow: hidden;
        transform: scale(0.41666666);
        transform-origin: 0 0;
        border: 1px solid rgba(205, 207, 212, 1);
    }
}
.show-preview {
    flex: 1;
    -webkit-flex: 1;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    -webkit-justify-content: center;
    .preview {
        overflow: hidden;
    }
}
.de-image-wrapper {
    display: inline-block;
    width: 120px;
    height: 120px;
    img {
        max-height: 100%;
        max-width: 100%;
        display: inline-block;
    }
}
</style>
<style>
.cropper-modal {
    background: none !important;
}
</style>
